import { httpMethod, useApi } from './useApi';
export const useCreateOrder = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'orders',
        httpMethod: httpMethod.POST,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
export const useGetOrders = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'orders',
        httpMethod: httpMethod.GET,
        body: {},
        queryParams: { limit: '1000' },
    });
    const responseData = data;
    return { call, data: responseData, error, ...rest };
};
export const useUpdateOrder = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'orders',
        httpMethod: httpMethod.PUT,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
export const useDeleteOrder = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'orders',
        httpMethod: httpMethod.DELETE,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
